import { Component, Input } from '@angular/core';
import { Constants } from '../../../shared/utilities/Constants';
import { CashBalance, CashType } from '../../models';

@Component({
  standalone: false,
  selector: 'mm-pal-balance',
  templateUrl: './pal-balance.component.html',
  styleUrls: ['./pal-balance.component.scss']  
})
export class PalBalanceComponent {
  @Input() balance: CashBalance;
  
  outstandingLoansTooltip: string = Constants.palOutstandingLoansTooltip;
  availableCreditTooltip: string = Constants.palAvailableCreditTooltip;
  creditLineTooltip: string = Constants.palCreditLineTooltip;
  financeChargesTooltip: string = Constants.palFinanceChargesTooltip;
  totalPaymentDueTooltip: string = Constants.palTotalPaymentDueTooltip;

  isNumber(val: number | string): boolean {
    return typeof val === 'number';
  }

  get displayTooltip(): boolean {
    return this.balance.type !== CashType.PaymentDueDate;
  }

  get tooltipVerbiage(): string {
    switch(this.balance.type) {
      case CashType.OutstandingLoans:
        return this.outstandingLoansTooltip;
      case CashType.AvailableCredit:
        return this.availableCreditTooltip;
      case CashType.CreditLine:
        return this.creditLineTooltip;
      case CashType.FinanceCharges:
        return this.financeChargesTooltip;
      case CashType.TotalPaymentDue:
        return this.totalPaymentDueTooltip;
      default:
        return '';
    }
  }
}
